module.exports = __webpack_public_path__ + "static/ITCAvantGardeStd-XLt-1aa00852b05ecd0b796410a40bab2cef.ttf";